<ng-template #details let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{ displaydetails.title }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="mb-3" *ngIf="displaydetails">
			<ng-container *ngIf="displaydetails.type == 'html'">
				<div [innerHTML]="displaydetails.display"></div>
			</ng-container>
			<ng-container *ngIf="displaydetails.type == 'pdf'">
				<ngx-extended-pdf-viewer
					[base64Src]="displaydetails.display"
					useBrowserLocale="true"
					[handTool]="false"
					[textLayer]="true"
					[showOpenFileButton]="false"
					[showPropertiesButton]="false"
					[showHandToolButton]="true"
					[filenameForDownload]="displaydetails.title"
				></ngx-extended-pdf-viewer>
			</ng-container>
		</div>
	</div>
	<div class="modal-footer"></div>
</ng-template>

<ng-template #orderView let-modal>
	<div class="modal-header">
		<div class="modal-title row m-0 p-0" id="modal-title">
			<h4>Orders</h4>
		</div>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="mb-3" *ngIf="orderdetails">
			<div class="table-responsive">
				<table class="table table-sm">
					<tr>
						<th>Order #</th>
						<th>Customer</th>
						<th>Type</th>
						<th class="text-center">Date</th>
						<th class="text-center">Salesman</th>
						<th class="text-end">Total</th>
						<th class="text-end">Units</th>
					</tr>
					<tr *ngFor="let item of orderdetails">
						<td>
							<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More" class="donotprint">
								<mat-icon>more_vert</mat-icon>
							</button>
							<mat-menu #menu="matMenu">
								<button mat-menu-item (click)="openDocument(item, details, 'html')">
									<mat-icon>visibility</mat-icon>
									<span>View HTML</span>
								</button>
								<button mat-menu-item (click)="openDocument(item, details, 'pdf')">
									<mat-icon>visibility</mat-icon>
									<span>View PDF</span>
								</button>
							</mat-menu>
							{{ item.transno }}
						</td>
						<td>{{ item.Customer }} — {{ item.Name }}</td>
						<td>{{ item.DocType }}</td>
						<td class="text-center">{{ item.Date }}</td>
						<td class="text-center">{{ item.Salesman }}</td>
						<td class="text-end">{{ item.Sales | currency }}</td>
						<td class="text-end">{{ (item.Units != null ? +item.Units : 0) | number : '1.0-3' }}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
	<div class="modal-footer"></div>
</ng-template>

<div class="main-content srpt-page">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card srpt-card">
					<div class="card-header card-header-{{ color }}-6">
						<h4 class="card-title">
							<i class="material-icons srpt-back" (click)="back()">arrow_back</i>
							Salesman Sales by Branch (SRPT)
						</h4>
						<p class="card-category text-right mb-0">Sales and units by location and salesperson</p>
					</div>
					<div class="card-body">
						<section class="srpt-filters" aria-label="Report filters">
							<div class="srpt-filters__head">
								<span class="srpt-filters__title">Filters</span>
								<span class="srpt-filters__hint">Choose branches and salespeople, optional dollar/unit floors, then run</span>
							</div>
							<form (ngSubmit)="$event.preventDefault(); getCRPT()">
								<div class="row g-3">
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 srpt-field">
											<mat-label>Date range</mat-label>
											<mat-select [formControl]="dateRangeCtrl">
												<mat-option *ngFor="let o of dateRangeOptions" [value]="o.value">{{ o.label }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-8" *ngIf="dateRangeCtrl.value === 'Custom'">
										<mat-form-field appearance="outline" class="w-100 srpt-field">
											<mat-label>Custom dates</mat-label>
											<mat-date-range-input [rangePicker]="srptPicker">
												<input matStartDate [formControl]="fromDateCtrl" placeholder="Start" />
												<input matEndDate [formControl]="toDateCtrl" placeholder="End" />
											</mat-date-range-input>
											<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
											<mat-datepicker-toggle matSuffix [for]="srptPicker"></mat-datepicker-toggle>
											<mat-date-range-picker #srptPicker></mat-date-range-picker>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 srpt-field">
											<mat-label>Salespeople</mat-label>
											<mat-select [formControl]="salespersonRef" multiple #salesFilter disableOptionCentering appSelectAll>
												<mat-select-trigger>{{ salesmanTriggerLabel }}</mat-select-trigger>
												<mat-option *ngFor="let k of salespeople" [value]="k.salesmancode">{{ k.salesmancode }} — {{ k.salesmanname }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 srpt-field">
											<mat-label>Branches</mat-label>
											<mat-select [formControl]="branchRef" multiple #branchFilter disableOptionCentering appSelectAll>
												<mat-select-trigger>{{ branchTriggerLabel }}</mat-select-trigger>
												<mat-option *ngFor="let k of branches" [value]="k.loccode">{{ k.locationname }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 srpt-field">
											<mat-label>Consolidated or branch</mat-label>
											<mat-select [formControl]="conBrRef">
												<mat-option *ngFor="let v of conbr" [value]="v.value">{{ v.label }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 srpt-field">
											<mat-label>Web orders</mat-label>
											<mat-select [formControl]="placedFromRef">
												<mat-option *ngFor="let v of placedfrom" [value]="v.value">{{ v.label }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 srpt-field">
											<mat-label>Min sales ($)</mat-label>
											<input matInput type="number" min="0" step="0.01" [formControl]="minSalesCtrl" placeholder="No minimum" />
											<mat-hint>Per salesperson row (HAVING)</mat-hint>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 srpt-field">
											<mat-label>Min units</mat-label>
											<input matInput type="number" min="0" step="0.01" [formControl]="minUnitsCtrl" placeholder="No minimum" />
											<mat-hint>Per salesperson row (HAVING)</mat-hint>
										</mat-form-field>
									</div>
								</div>
								<div class="srpt-actions">
									<button mat-raised-button color="accent" type="submit" class="srpt-actions__primary" [disabled]="sending">
										<mat-icon>search</mat-icon>
										Run report
									</button>
									<span *ngIf="sending" class="srpt-actions__spinner">
										<mat-spinner diameter="36"></mat-spinner>
									</span>
									<div class="srpt-actions__exports" *ngIf="hasResults">
										<button
											type="button"
											class="btn btn-success btn-sm srpt-export"
											(click)="$event.preventDefault(); exportXls()"
											matTooltip="Export spreadsheet"
										>
											<i class="fa fa-file-excel-o"></i> XLS
										</button>
										<button
											type="button"
											class="btn btn-danger btn-sm srpt-export"
											(click)="$event.preventDefault(); exportPdf()"
											matTooltip="Export PDF"
										>
											<i class="fa fa-file-pdf-o"></i> PDF
										</button>
									</div>
								</div>
							</form>
						</section>

						<section class="srpt-results" *ngIf="reportCriteria && hasResults">
							<div class="srpt-results__heading">
								<h3 class="srpt-results__title">
									Salesman sales
									<span class="srpt-results__dates" *ngIf="reportCriteria.fromdate && reportCriteria.todate">
										{{ reportCriteria.fromdate | date : 'MM/dd/yy' }} – {{ reportCriteria.todate | date : 'MM/dd/yy' }}
									</span>
								</h3>
								<p class="srpt-results__subtitle" *ngIf="getReportSubtitle()">{{ getReportSubtitle() }}</p>
							</div>
							<div class="srpt-kpi-grid" role="group" aria-label="Report summary">
								<div class="srpt-kpi">
									<span class="srpt-kpi__label">Locations</span>
									<span class="srpt-kpi__value">{{ locationBlockCount | number : '1.0-0' }}</span>
								</div>
								<div class="srpt-kpi">
									<span class="srpt-kpi__label">Salesperson rows</span>
									<span class="srpt-kpi__value">{{ dataRowCount | number : '1.0-0' }}</span>
								</div>
								<div class="srpt-kpi">
									<span class="srpt-kpi__label">Avg / row</span>
									<span class="srpt-kpi__value srpt-kpi__value--money">{{ orderResults.avg | currency }}</span>
									<span class="srpt-kpi__sub" *ngIf="orderResults.avgunits != null">{{ orderResults.avgunits | number : '1.0-2' }} units</span>
								</div>
								<div class="srpt-kpi srpt-kpi--featured">
									<span class="srpt-kpi__label">Grand total</span>
									<span class="srpt-kpi__value srpt-kpi__value--money">{{ grandTotals.sales | currency }}</span>
									<span class="srpt-kpi__sub">{{ grandTotals.units | number : '1.0-3' }} units</span>
								</div>
							</div>
						</section>

						<div class="srpt-table-panel" *ngIf="hasResults">
							<div class="srpt-table-panel__bar">
								<span class="srpt-table-panel__label">By branch</span>
								<span class="srpt-table-panel__meta">
									{{ dataRowCount | number }} rows · click column headers to sort within each branch
								</span>
							</div>
							<div class="srpt-table-wrap">
								<ng-container *ngFor="let brKey of branchKeysSorted">
									<table class="srpt-table" *ngIf="orderResults.lines[brKey] as block">
										<thead>
											<tr>
												<th class="srpt-th srpt-th--section" colspan="5">{{ getBranchName(brKey) }}</th>
											</tr>
											<tr>
												<th class="srpt-th srpt-th--sort" (click)="setBranchSort(brKey, 'br')">
													BR <mat-icon class="srpt-sort-icon">{{ sortIcon(brKey, 'br') }}</mat-icon>
												</th>
												<th class="srpt-th srpt-th--sort" (click)="setBranchSort(brKey, 'salesman')">
													Sales ID <mat-icon class="srpt-sort-icon">{{ sortIcon(brKey, 'salesman') }}</mat-icon>
												</th>
												<th class="srpt-th srpt-th--sort srpt-th--name" (click)="setBranchSort(brKey, 'salesmanname')">
													Name <mat-icon class="srpt-sort-icon">{{ sortIcon(brKey, 'salesmanname') }}</mat-icon>
												</th>
												<th class="srpt-th srpt-th--sort srpt-th--num" (click)="setBranchSort(brKey, 'sales')">
													Sales <mat-icon class="srpt-sort-icon">{{ sortIcon(brKey, 'sales') }}</mat-icon>
												</th>
												<th class="srpt-th srpt-th--sort srpt-th--num" (click)="setBranchSort(brKey, 'units')">
													Units <mat-icon class="srpt-sort-icon">{{ sortIcon(brKey, 'units') }}</mat-icon>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												*ngFor="let line of sortedLinesForBranch(brKey, block.l); let ri = index"
												class="srpt-data-row"
												[class.srpt-data-row--alt]="ri % 2 === 1"
											>
												<td class="srpt-cell">{{ line.BR }}</td>
												<td class="srpt-cell">
													<a class="srpt-link" (click)="viewCustomer(line.Salesman, line.BR)">{{ line.Salesman }}</a>
												</td>
												<td class="srpt-cell srpt-cell--name" [matTooltip]="line.Salesmanname">{{ line.Salesmanname }}</td>
												<td class="srpt-cell srpt-cell--num">{{ line.Sales | currency }}</td>
												<td class="srpt-cell srpt-cell--num">{{ (line.Units != null ? +line.Units : 0) | number : '1.0-3' }}</td>
											</tr>
											<tr class="srpt-subtotal-row">
												<td class="srpt-cell" colspan="3">Subtotal</td>
												<td class="srpt-cell srpt-cell--num">{{ block.total | currency }}</td>
												<td class="srpt-cell srpt-cell--num">{{ (block.totalunits != null ? +block.totalunits : 0) | number : '1.0-3' }}</td>
											</tr>
										</tbody>
									</table>
								</ng-container>
							</div>
						</div>

						<div *ngIf="reportCriteria && !sending && !hasResults" class="srpt-empty">
							<mat-icon>search_off</mat-icon>
							<p>No rows matched the selected criteria.</p>
							<span class="srpt-empty__hint">Widen the date range, clear min sales/units, or pick more branches or salespeople.</span>
						</div>

						<p class="srpt-placeholder text-muted" *ngIf="!reportCriteria && !sending">Set filters above and run the report.</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
